import React, { useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import useAuthAxios from "../../../utils/baseAxios";
import { API } from "../../../constants/api";
import { toast } from "react-hot-toast";
import { useMutation } from "@tanstack/react-query";
import ClipLoader from "react-spinners/ClipLoader";
import { errorMessage } from "../../../utils/errorMessage";
import OtpPin from "../../../components/OtpPin";
import { useUser } from "../../../context/user-context";

const ChangeTxnPin = ({ setOpenPin }: any) => {
  const { userDetails, refetch } = useUser();
  const axiosInstance = useAuthAxios();
  const [otp, setOtp] = useState<string>("");
  const [pinC, setPinC] = useState<string>("");
  const [pin, setPin] = useState<string>("");
  const pinAvailable = userDetails?.user?.isPinSelected;

  const [screen, setScreen] = useState<number>(1);

  const createPin = async ({ pin }: any) => {
    const response = await axiosInstance.post(API.createPin, {
      pin,
    });
    return response.data;
  };
  const completeCreatePin = useMutation({
    mutationFn: createPin,
    onSuccess: async (r) => {
      toast.success(r.message);
      // Close only once userDetails reflects isPinSelected — the dashboard
      // reopens this modal while the cached flag is still false.
      await refetch();
      setOpenPin(false);
    },
    onError: (e) => {
      // console.log(e);
      const err = e as any;
      toast.error(errorMessage(err?.message || err?.data?.message));
    },
  });
  const changePin = async ({ otp, newPin }: any) => {
    const response = await axiosInstance.post(API.changePin, {
      otp,
      newPin,
    });
    return response.data;
  };
  const completeChangePin = useMutation({
    mutationFn: changePin,
    onSuccess: (r) => {
      toast.success(r.message);
      refetch();
      setTimeout(() => {
        setOpenPin(false);
      }, 2000);
    },
    onError: (e) => {
      // console.log(e);
      const err = e as any;
      toast.error(errorMessage(err?.message || err?.data?.message));
    },
  });

  const sendPINotp = async ({ purpose }: any) => {
    const response = await axiosInstance.post(API.requestOTP, {
      purpose,
    });
    return response.data;
  };
  const completeSendPinOTP = useMutation({
    mutationFn: sendPINotp,
    onSuccess: (r) => {
      toast.success(r.message);
      setTimeout(() => {
        setScreen(3);
      }, 1500);
    },
    onError: (e) => {
      console.log(e);
      const err = e as any;
      toast.error(errorMessage(err?.message || err?.data?.message));
    },
  });
  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
              if (screen === 1) {
                setOpenPin(false);
              } else if (screen === 2) {
                setScreen(1);
              } else if (screen === 3) {
                setScreen(2);
              }
            }}
          >
            <BsArrowLeft className="text-black dark:text-white text-[20px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[20px]">
            Security settings
          </h4>
        </div>
        <div className="mt-8 w-full">
          {screen === 1 ? (
            <div className="mt-8 w-full">
              <h4 className="text-[16px] mt-6 text-gray-700 dark:text-gray-300 font-semibold  text-center">
                Enter new PIN
              </h4>
              <h4 className="text-[14px] mt-1  text-gray-600 dark:text-gray-400 mb-8 text-center ">
                Enter your new transaction PIN
              </h4>
              <OtpPin otp={pin} input={4} setOtp={setPin} />
              <button
                onClick={() => {
                  setScreen(2);
                }}
                disabled={pin.length !== 4}
                className={
                  pin.length !== 4
                    ? "w-full bg-gray-400 rounded-xl flex justify-center items-center text-gray-100 text-[15px] font-medium mt-48 h-[48px]"
                    : "w-full bg-secondary_button rounded-xl flex justify-center items-center text-white text-[15px] font-medium mt-48 h-[48px]"
                }
              >
                Proceed
              </button>
            </div>
          ) : screen === 2 ? (
            <div className="mt-8 w-full">
              <h4 className="text-[16px] mt-6 text-gray-700 dark:text-gray-300 font-semibold  text-center">
                Re-enter {pinAvailable && "new"} PIN
              </h4>
              <h4 className="text-[14px] mt-1  text-gray-600 dark:text-gray-400 mb-8 text-center ">
                Enter your {pinAvailable && "new"} transaction PIN again
              </h4>
              <OtpPin otp={pinC} input={4} setOtp={setPinC} />
              <button
                onClick={() => {
                  if (pinC === pin) {
                    setScreen(3);
                    if (pinAvailable) {
                      completeSendPinOTP.mutate({
                        purpose: "change-pin",
                      });
                    } else {
                      completeCreatePin.mutate({
                        pin: pin,
                      });
                    }
                  }
                }}
                disabled={pinC.length !== 4}
                className={
                  pinC.length !== 4
                    ? "w-full bg-gray-400 rounded-xl flex justify-center items-center text-gray-100 text-[15px] font-medium mt-48 h-[48px]"
                    : "w-full bg-secondary_button rounded-xl flex justify-center items-center text-white text-[15px] font-medium mt-48 h-[48px]"
                }
              >
                {completeCreatePin.isPending ? (
                  <ClipLoader color="#ffffff" size={20} />
                ) : (
                  "Change PIN"
                )}
              </button>
            </div>
          ) : screen === 3 ? (
            <div className="mt-10 w-full">
              <h4 className="font-manrope w-full mb-6 dark:text-gray-200 text-gray-800 text-center font-medium text-[14px] ">
                Enter the 6-digit verification code sent to your email to verify
                this action.
                <br />
                Not receiving OTP? Chack spam folder.
              </h4>
              <OtpPin otp={otp} setOtp={setOtp} input={6} />
              <button
                onClick={() => {
                  completeChangePin.mutate({
                    otp: otp,
                    newPin: pin,
                  });
                }}
                disabled={otp.length !== 6 || completeChangePin.isPending}
                className={
                  otp.length !== 6
                    ? "w-full bg-gray-400 rounded-xl flex justify-center items-center text-gray-100 text-[15px] font-medium mt-48 h-[48px]"
                    : "w-full bg-secondary_button rounded-xl flex justify-center items-center text-white text-[15px] font-medium mt-48 h-[48px]"
                }
              >
                {completeChangePin.isPending ? (
                  <ClipLoader color="#ffffff" size={20} />
                ) : (
                  "Change PIN"
                )}
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ChangeTxnPin;
